// extracted by mini-css-extract-plugin
export default {"container":"getNotificationNodeWithAction_container__a9INX"};